import React from "react";
import Dashnavbar from "./dashnavbar";

const Listingnavbar = () => {
  return (
    <>
      <div className="listing-navbar d-flex  h-center pt-4">
        {/* <div className="listing-logo-container">
          <img
            src="../../assets/images/logoColoured.png"
            alt="logo"
            className="logo"
          />
        </div> */}
        <Dashnavbar hide="d-none"/>
      </div>
    </>
  );
};

export default Listingnavbar;
